<template>
  <vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired" v-bind:sitekey="sitekey"></vue-recaptcha>
</template>

<script>
	import { VueRecaptcha } from 'vue-recaptcha';
	import store from '../store'
	export default {
		props: ['sitekey', 'name', 'validate-form'],
		components: { VueRecaptcha },
		methods: {
			onSubmit: function () {
				console.log("recaptcha-onsubmit");
			},
			onVerify: function (response) {
				console.log("recaptcha-onverify");
				console.log("siteKeyV2 : "+this.sitekey)
				console.log('Verify: ' + response)
				console.log("component name : "+this.name);

				if(this.name == "register"){
					let registrationData = store.state.registration;
					registrationData.recaptchaV2 = response;
					this.$emit('validate-form');
				}

				if(this.name == "login"){ /* to be distinguished */
					let registrationData = store.state.registration;
					registrationData.recaptchaV2 = response;
					this.$emit('validate-form');
				}
			},
			onExpired: function () {
				console.log("recaptcha-onexpired");
				if(this.name == "register"){
					let registrationData = store.state.registration;
					registrationData.recaptchaV2 = "";
					this.$emit('validate-form');
				}

				if(this.name == "login"){ /* to be distinguished */
					let registrationData = store.state.registration;
					registrationData.recaptchaV2 = "";
					this.$emit('validate-form');
				}
			},
			resetRecaptcha() {
				this.$refs.recaptcha.reset() // Direct call reset method
			},
		},
	};
</script>